// removed by extract-text-webpack-plugin
module.exports = {"usDollarsNotice":"usDollarsNotice-module_usDollarsNotice_3-lTJ"};


//////////////////
// WEBPACK FOOTER
// ./client/components/usDollarsNotice/usDollarsNotice.module.css
// module id = 265
// module chunks = 1 2 3